<!--
 * @Author: wjl
 * @Date: 2020-08-13 09:54:04
 * @LastEditors: hxz
 * @LastEditTime: 2023-04-07 10:22:34
 * @FilePath: \appOfficial\src\views\leader.vue
-->
<template>
  <div class="contiraner">
    <div v-for="(item, index) in leaderList" :key="index" class="leaderItem">
      <img :src="item.img" alt />
      <p>{{ item.name }}</p>
      <p v-html="item.content" class="content"></p>
    </div>
    <div class="listBox">
      <div v-for="(item, index) in seconList" :key="index" class="seconItem">
        <img
          :src="item.img ? item.img : require('../images/leader/nomore.png')"
          alt
          srcset
        />
        <p>{{ item.name }}</p>
        <p>{{ item.content }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "leader",
  data() {
    return {
      leaderList: [
        {
          img: require("../images/leader/dhf.png"),
          name: "刁海峰",
          content:
            "网上老年大学名誉校长<br/>中国老年大学协会常务副会长<br/>中国老年大学艺术团名誉团长",
        },
        {
          img: require("../images/leader/lch.png"),
          name: "李春华",
          content:
            "网上老年大学校长<br/>现任中国老年大学协会副秘书长<br/>协会办公室主任<br/>中国老年大学艺术团团长",
        },
      ],
      seconList: [],
    };
  },
};
</script>

<style lang="scss" scoped>
.contiraner {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 15px;
  .leaderItem {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: rgba(247, 247, 247, 1);
    border-radius: 0.5rem;
    padding: 1.5625rem 0 1.625rem 0;
    margin-bottom: 0.9375rem;
    img {
      width: 4.0625rem;
      height: 4.0625rem;
    }
    p:nth-child(2) {
      font-size: 1.1875rem;
      font-weight: 800;
      color: rgba(51, 51, 51, 1);
      margin: 0.625rem 0 0.25rem 0;
    }
    .content {
      line-height: 0.9375rem;
      text-align: center;
      line-height: 1.3125rem;
      font-size: 0.9375rem;
      color: rgba(102, 102, 102, 1);
    }
  }
  .listBox {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .seconItem {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: column;
      width: 48%;
      background: rgba(247, 247, 247, 1);
      border-radius: 0.5rem;
      margin-bottom: 0.9375rem;
      padding: 1.5625rem 0.9375rem 1.3125rem 0.9375rem;
      box-sizing: border-box;
      img {
        width: 4rem;
        height: 4rem;
        border-radius: 50%;
      }
      p:nth-child(2) {
        font-size: 1.1875rem;
        font-weight: 800;
        color: rgba(51, 51, 51, 1);
        margin: 0.6875rem 0 0.25rem 0;
      }
      p:nth-child(3) {
        text-align: center;
        font-size: 0.9375rem;
        color: rgba(102, 102, 102, 1);
      }
    }
  }
}
</style>
